import React from 'react';
import { TierMap } from 'entity/reward/rewardTypes';
import { ChevronRight, Gift } from 'react-feather';
import { openCreditHistoryModal } from 'dispatcher/modalDispatcher';
import mixpanel, { trackedEvents } from 'utils/mixpanel';
import { rewardOnboarding } from 'theme';
import Image from 'next/image';
import { useDispatch, useSelector } from 'react-redux';
import { RootState } from 'reducer';
import clsx from 'clsx';

interface OwnProps {
  onClick?: () => void;
}

const EnrolledUserDashboard = (props: OwnProps) => {
  const dispatch = useDispatch();
  const { onClick } = props;
  const profile = useSelector((state: RootState) => state.profile.user);

  const creditsCount = profile?.creditsCount || 0;
  const expiringCredits = profile?.expiringCredits || 0;

  const tier = profile?.tier || 1;

  return (
    <div
      className={clsx(
        'flex flex-col gap-3 w-full',
        onClick && 'cursor-pointer',
      )}
      onClick={onClick}
    >
      <div className="flex w-full justify-between items-center">
        <div className="flex items-center gap-1">
          <Gift size={16} color="white" />
          <p className="text-xs font-bold uppercase text-white">
            SEEDLY REWARDS
          </p>
        </div>
        <p className="text-xs font-bold uppercase text-white">
          {TierMap[tier]}
        </p>
      </div>
      <div className="flex items-center gap-2">
        <Image src={rewardOnboarding.singleCoin} height={36} width={36} />
        <p className="text-[32px] font-bold text-white">
          {creditsCount?.toLocaleString()} Credits
        </p>
      </div>
      <div className="horizontal-divider " />
      <div className="flex items-center gap-4 w-full">
        <div className="flex flex-col w-1/2">
          <p className="text-sm font-bold text-white">
            {expiringCredits} Credits
          </p>
          <p className="text-xs text-white">Expiring this month</p>
        </div>
        <div className="vertical-divider h-9" />
        <div
          className="flex w-1/2 justify-between items-center cursor-pointer"
          onClick={e => {
            // stop overlap from outer event;
            e.stopPropagation();

            dispatch(openCreditHistoryModal());
            mixpanel.track(trackedEvents.RewardsCollection, {
              param: 'credit_history_rewards',
            });
          }}
        >
          <p className="text-sm font-bold text-white">Credit History</p>
          <ChevronRight size={20} color="white" />
        </div>
      </div>
    </div>
  );
};

export default EnrolledUserDashboard;
